import {Component} from '@angular/core';
import {AsyncPipe} from "@angular/common";
import {
    DxDateRangeBoxComponent, DxFormComponent, DxTextAreaComponent,
    DxValidatorComponent
} from "devextreme-angular";
import {
    AccessType,
    ChangeFloaterDayStatusCommand,
    CreateFloaterDayCommand,
    EmployeeDto,
    FloaterDayGridViewDto, PermissionType, TimeOffStatus
} from "@services";
import {DxiItemComponent, DxiValidationRuleComponent} from "devextreme-angular/ui/nested";
import {TimeOffRequestModalComponent} from "../../time-off-request-modal/time-off-request-modal.component";
import TimeOffPopupComponent from "../../time-off-popup.component";
import {PicturedItemSelectBoxComponent} from "../../../../../components";

@Component({
    selector: 'app-floater-day-popup',
    imports: [
        AsyncPipe,
        DxDateRangeBoxComponent,
        DxiValidationRuleComponent,
        TimeOffRequestModalComponent,
        DxFormComponent,
        DxTextAreaComponent,
        DxiItemComponent,
        PicturedItemSelectBoxComponent,
        DxValidatorComponent
    ],
    templateUrl: './floater-day-popup.component.html'
})
export class FloaterDayPopupComponent extends TimeOffPopupComponent<FloaterDayGridViewDto> {
    onSave() {
        let createLieuDayCommand = new CreateFloaterDayCommand({
            requestedStartDate: this.formData.requestedStartDate,
            requestedEndDate: this.formData.requestedEndDate,
            userId: this.formData.employee.id,
            description: this.formData.description
        });

        this.timeOffClient.createFloaterDay(createLieuDayCommand).subscribe({
            next: () => this.handleSuccess(),
            error: (errors) => this.handleError(errors)
        });
    };

    async loadData() {
        if (this.request) {
            this.formData = new FloaterDayGridViewDto();
            this.formData.init(this.request);
        } else {
            this.formData = new FloaterDayGridViewDto();
            this.formData.init({
                employee: this.canShowInSelectBox ? new EmployeeDto({id: this.auth.userId}) : new EmployeeDto()
            });
            this.formData.requestedStartDate = null;
            this.formData.requestedEndDate = null
        }
        this.employeeId.next(this.formData.employee.id);
        this.startDate.next(this.formData.requestedStartDate);
        this.endDate.next(this.formData.requestedEndDate);
    }

    changeStatus(status: TimeOffStatus) {
        let changeStatusCommand = new ChangeFloaterDayStatusCommand({
            id: this.formData.id,
            status: status
        });

        this.timeOffClient.changeFloaterDayStatus(changeStatusCommand).subscribe({
            next: () => this.handleSuccess(),
            error: (errors) => this.handleError(errors)
        });
    }

    protected override get canApprove(): boolean {
        return super.canApprove && this.auth.checkPermission(PermissionType.FloaterDayRequests, AccessType.Manage);
    };

    protected override get canDecline(): boolean {
        return super.canDecline && this.auth.checkPermission(PermissionType.FloaterDayRequests, AccessType.Manage);
    };

    protected get canEditEmployee(): boolean{
        return super.canEditEmployee && this.auth.checkPermission(PermissionType.FloaterDayRequests, AccessType.Manage);
    }
}
